import mixpanel from 'mixpanel-browser';

import { getPortalRuntimeConfig } from '../services/runtimeConfig';
import { isAutomationEnvironment } from './automation';
import getEnvironment from './environment';

let mixPanelEnabled = false;

export function init() {
  const token = getPortalRuntimeConfig().mixpanel.token;
  if (!token) {
    if (!getEnvironment().isProd) console.warn('No mixpanel token given!');
    mixPanelEnabled = false;
    return;
  }

  if (isAutomationEnvironment()) {
    if (!getEnvironment().isProd) console.warn('Mixpanel disabled in automation environment');
    mixPanelEnabled = false;
    return;
  }

  mixPanelEnabled = true;
  mixpanel.init(token, { persistence: 'localStorage' });
  if (!getEnvironment().isProd) console.debug('Init mixpanel');
}

export function identify({
  user,
  organization,
}: {
  user: { uuid: string; email?: string };
  organization?: string;
}) {
  if (!mixPanelEnabled) {
    return;
  }

  mixpanel.people.set({
    $email: user.email,
    organization,
    uuid: user?.uuid,
  });
  mixpanel.identify(user.uuid);
}

export function track(type: string, data?: any) {
  if (!mixPanelEnabled) {
    return;
  }

  mixpanel.track(type, data);
}

export function trackTiming(type: string) {
  if (!mixPanelEnabled) {
    return;
  }
  mixpanel.time_event(type);
}

export function logout() {
  if (!mixPanelEnabled) {
    return;
  }
  mixpanel.reset();
}

export function setCustomerViewProperty(isCustomerView: boolean) {
  if (!mixPanelEnabled) {
    return;
  }
  if (isCustomerView) {
    mixpanel.register({ customer_view: true });
  } else {
    mixpanel.unregister('customer_view');
  }
}
